import type { IDBSection } from '@/datastore/types'
import type { MemoItem } from '@/shared/templates/memos/lib/renderMemo'
import type { MemoSection } from './fileSection'

/**
 * The one section every picked item with a section belongs to. Items without
 * one (print articles) say nothing either way, and a selection spanning more
 * than one section, or naming one the datastore has no record of, has none.
 */
export function sharedSection(
  items: MemoItem[],
  sections: IDBSection[]
): MemoSection | undefined {
  const uuids = new Set(items.flatMap((item) => item.sectionUuid ? [item.sectionUuid] : []))

  if (uuids.size !== 1) {
    return undefined
  }

  const [uuid] = [...uuids]
  const match = sections.find((section) => section.id === uuid)

  if (!match) {
    return undefined
  }

  return { uuid: match.id, title: match.title }
}
